import { v4 as uuidv4 } from 'uuid';
import { CanvasEx } from '@/typings/canvas';
import { BaseCanvasElement } from '@/typings/customilyElements/canvasElements';
import { ElementsGroup, GroupType } from '@/typings/customilyElements/elementsGroup';

export const createGroup = (
    canvas: CanvasEx,
    options: {
        type: GroupType;
        zIndex: number;
        parentId: string;
        name?: string;
        spotifyPlayer?: boolean;
        isLayout: boolean;
    }
): ElementsGroup => {
    const groups = canvas.getElementsGroups() || [];
    const maxPosition = Math.max(...groups.map((g) => g.position), 0);
    const layout = {
        id: uuidv4(),
        uuid: uuidv4(),
        locked: false,
        visible: true,
        name: options.name || 'Layout',
        type: options.type,
        pageEpsId: canvas.getFirstActivePageEpsId(),
        zIndex: options.zIndex,
        position: maxPosition + 1,
        parentId: options.parentId,
        SpotifyPlayer: options.spotifyPlayer || undefined,
        isLayout: options.isLayout
        // check
        // position: props.allowPositionGroupEdit ? canvas?.getMaxPositionGroup() || 0 : 0
    };

    return layout;
};

export const setGroupLock = (group: ElementsGroup, canvas: CanvasEx, locked: boolean) => {
    if (!group) return;
    group.locked = locked;
    const elements: BaseCanvasElement[] = canvas.getGroupElements(group);
    for (const element of elements) {
        element.set('dirty', true);
        canvas.fire('object:modified', {
            target: element
        });
    }
    const childGroupsFound = canvas.getElementsGroups().filter((g) => g.parentId === group.id);
    if (!childGroupsFound?.length) {
        canvas.requestRenderAll();
        return;
    }
    for (const childGroup of childGroupsFound) {
        setGroupLock(childGroup, canvas, locked);
    }
    canvas.requestRenderAll();
};
